import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class SpendingRequestDetail  {
    _originalTypeClassName = "zERP.BO.SpendingRequestDetail";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
SpendingRequestDetail.translate = translateService;
}
this.InvoicingInfo = [];
this.NonDeductibleVATInvoicingInfo = [];
this.PaymentOrderDetails = [];
this.Id = null;
this.TotalAmount = null;
this.ApprovedAmount = null;
this.InvoicedAmount = null;
this.RemainingAmount = null;
this.Quantity = null;
this.RemainingQuantity = null;
this.Description = null;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
TotalAmount:any;
ApprovedAmount:any;
InvoicedAmount:any;
RemainingAmount:any;
Quantity:any;
RemainingQuantity:any;
Description:any;
SpendingRequest:any;
Item:any;
Good:any;
InvoicingInfo:any;
NonDeductibleVATInvoicingInfo:any;
Note:any;
PaymentOrderDetails:any;
static setSpendingRequest = ($this, value) => {
var oldValue = $this.SpendingRequest;
$this.SpendingRequest = value;
if (value != null) {
if (oldValue != null) {
Domain.SpendingRequest.removeDetails(oldValue, $this);
}
Domain.SpendingRequest.addDetails(value, $this);
}
}
static setItem = ($this, value) => {
var oldValue = $this.Item;
$this.Item = value;
if (value != null) {
if (oldValue != null) {
Domain.BudgetDetail.removeSpendingRequests(oldValue, $this);
}
Domain.BudgetDetail.addSpendingRequests(value, $this);
}
}
static setGood = ($this, value) => {
var oldValue = $this.Good;
$this.Good = value;
if (value != null) {
}
}
static setInvoicingInfo = ($this, items) => {
                if (items == null) items = [];
                if ($this.InvoicingInfo == null) $this.InvoicingInfo = [];

                const copyItems = Common.cloneObject(items);

                while ($this.InvoicingInfo.length > 0) {
                    Domain.SpendingRequestDetail.removeInvoicingInfo($this, $this.InvoicingInfo[0]);
                }

                Domain.SpendingRequestDetail.addManyInvoicingInfo($this, copyItems);
            }
static addManyInvoicingInfo = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpendingRequestDetail.addInvoicingInfo($this, items[i]);
                }
            }
static addInvoicingInfo = ($this, item) => {
                if ($this.InvoicingInfo == null) $this.InvoicingInfo = [];
                if (item == null || $this.InvoicingInfo.indexOf(item) > -1) return;
                $this.InvoicingInfo.push(item);
if (item.SpendingRequestDetail != $this) {
Domain.SpendingRequestInvoicing.setSpendingRequestDetail(item, $this);
}
}
static addRangeInvoicingInfo = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpendingRequestDetail.addInvoicingInfo($this, item));
            }
static removeInvoicingInfo = ($this, item) => {
                if ($this == null || $this.InvoicingInfo == null || $this.InvoicingInfo.indexOf(item) === -1) return;
                var _index = $this.InvoicingInfo.indexOf(item);
                $this.InvoicingInfo.splice(_index, 1);
item.SpendingRequestDetail = null;
}
static clearInvoicingInfo = ($this) => { $this.InvoicingInfo = null; }
static setNonDeductibleVATInvoicingInfo = ($this, items) => {
                if (items == null) items = [];
                if ($this.NonDeductibleVATInvoicingInfo == null) $this.NonDeductibleVATInvoicingInfo = [];

                const copyItems = Common.cloneObject(items);

                while ($this.NonDeductibleVATInvoicingInfo.length > 0) {
                    Domain.SpendingRequestDetail.removeNonDeductibleVATInvoicingInfo($this, $this.NonDeductibleVATInvoicingInfo[0]);
                }

                Domain.SpendingRequestDetail.addManyNonDeductibleVATInvoicingInfo($this, copyItems);
            }
static addManyNonDeductibleVATInvoicingInfo = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpendingRequestDetail.addNonDeductibleVATInvoicingInfo($this, items[i]);
                }
            }
static addNonDeductibleVATInvoicingInfo = ($this, item) => {
                if ($this.NonDeductibleVATInvoicingInfo == null) $this.NonDeductibleVATInvoicingInfo = [];
                if (item == null || $this.NonDeductibleVATInvoicingInfo.indexOf(item) > -1) return;
                $this.NonDeductibleVATInvoicingInfo.push(item);
if (item.NonDeductibleVATSpendingRequestDetail != $this) {
Domain.SpendingRequestInvoicing.setNonDeductibleVATSpendingRequestDetail(item, $this);
}
}
static addRangeNonDeductibleVATInvoicingInfo = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpendingRequestDetail.addNonDeductibleVATInvoicingInfo($this, item));
            }
static removeNonDeductibleVATInvoicingInfo = ($this, item) => {
                if ($this == null || $this.NonDeductibleVATInvoicingInfo == null || $this.NonDeductibleVATInvoicingInfo.indexOf(item) === -1) return;
                var _index = $this.NonDeductibleVATInvoicingInfo.indexOf(item);
                $this.NonDeductibleVATInvoicingInfo.splice(_index, 1);
item.NonDeductibleVATSpendingRequestDetail = null;
}
static clearNonDeductibleVATInvoicingInfo = ($this) => { $this.NonDeductibleVATInvoicingInfo = null; }
static setNote = ($this, value) => {
var oldValue = $this.Note;
$this.Note = value;
if (value != null) {
}
}
static setPaymentOrderDetails = ($this, items) => {
                if (items == null) items = [];
                if ($this.PaymentOrderDetails == null) $this.PaymentOrderDetails = [];

                const copyItems = Common.cloneObject(items);

                while ($this.PaymentOrderDetails.length > 0) {
                    Domain.SpendingRequestDetail.removePaymentOrderDetails($this, $this.PaymentOrderDetails[0]);
                }

                Domain.SpendingRequestDetail.addManyPaymentOrderDetails($this, copyItems);
            }
static addManyPaymentOrderDetails = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.SpendingRequestDetail.addPaymentOrderDetails($this, items[i]);
                }
            }
static addPaymentOrderDetails = ($this, item) => {
                if ($this.PaymentOrderDetails == null) $this.PaymentOrderDetails = [];
                if (item == null || $this.PaymentOrderDetails.indexOf(item) > -1) return;
                $this.PaymentOrderDetails.push(item);
if (item.SpendingRequestDetail != $this) {
Domain.PaymentOrderDetail.setSpendingRequestDetail(item, $this);
}
}
static addRangePaymentOrderDetails = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.SpendingRequestDetail.addPaymentOrderDetails($this, item));
            }
static removePaymentOrderDetails = ($this, item) => {
                if ($this == null || $this.PaymentOrderDetails == null || $this.PaymentOrderDetails.indexOf(item) === -1) return;
                var _index = $this.PaymentOrderDetails.indexOf(item);
                $this.PaymentOrderDetails.splice(_index, 1);
item.SpendingRequestDetail = null;
}
static clearPaymentOrderDetails = ($this) => { $this.PaymentOrderDetails = null; }


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}